import { TransactionalManagementIndicators } from "./transactional-management-indicators";
import { TransactionalManagementSale } from "./transactional-management-sale";
import { TransactionalManagementRequest } from "./transactional-management.request";

export class TransactionalManagementResult {
  private request: TransactionalManagementRequest;
  private start: number;
  private total: number;
  private totalPerPages: number;
  private sales: TransactionalManagementSale[];
  private indicators: TransactionalManagementIndicators;

  constructor() {
    this.sales = [];
  }

  public getRequest(): TransactionalManagementRequest {
    return this.request;
  }

  public setRequest(value: TransactionalManagementRequest): void {
    this.request = value;
  }

  public getStart(): number {
    return this.start;
  }

  public setStart(value: number): void {
    this.start = value;
  }

  public getTotal(): number {
    return this.total;
  }

  public setTotal(value: number): void {
    this.total = value;
  }

  public getTotalPerPages(): number {
    return this.totalPerPages;
  }

  public setTotalPerPages(value: number): void {
    this.totalPerPages = value;
  }

  public getSales(): TransactionalManagementSale[] {
    return this.sales;
  }

  public setSales(value: TransactionalManagementSale[]) {
    this.sales = value;
  }

  public addSales(value: TransactionalManagementSale[]): void {
    this.sales = this.sales.concat(value);
  }

  public hasSalesItem(): boolean {
    return this.sales.length > 0;
  }

  public getIndicators(): TransactionalManagementIndicators {
    return this.indicators;
  }

  public setIndicators(value: TransactionalManagementIndicators): void {
    this.indicators = value;
  }
}
